<script module lang="ts">
  // Harmonize section labels width across components
  let labelMinWidth = $state(0)
</script>
<script lang="ts">
  import { isPropertyUri } from '#app/lib/boolean_tests'
  import { onChange } from '#app/lib/svelte/svelte'
  import { loadInternalLink } from '#app/lib/utils'
  import type { EntityUri, PropertyUri } from '#server/types/entity'
  import { i18n } from '#user/lib/i18n'

  const {
    label,
    entitiesLength,
    filteredEntitiesLength,
    property,
    uri,
    alignedWidth = false,
  }: {
    label: string
    entitiesLength: number
    filteredEntitiesLength?: number
    property?: PropertyUri
    uri?: EntityUri
    alignedWidth?: boolean
  } = $props()

  let labelWidth = $state(0)
  $effect(() => {
    if (alignedWidth) {
      onChange(labelWidth, () => {
        labelMinWidth = Math.max(labelMinWidth, labelWidth)
      })
    }
  })
</script>

{#if label}
  <div
    class="label-wrapper"
    style:min-width={alignedWidth ? `${labelMinWidth}px` : 'auto'}
    bind:clientWidth={labelWidth}
  >
    <div class="left-section">
      <h3>
        {label}
        {#if entitiesLength > 0}
          <span class="counter">
            {#if filteredEntitiesLength != null && filteredEntitiesLength >= 0 && filteredEntitiesLength !== entitiesLength}
              {filteredEntitiesLength} /
            {/if}
            {entitiesLength}
          </span>
        {/if}
      </h3>
    </div>
    {#if isPropertyUri(property)}
      <a
        class="show-advanced-list-browser"
        href={`/entity/${property}-${uri}`}
        onclick={loadInternalLink}
      >
        {i18n('Open in advanced list browser')}
      </a>
    {/if}
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .label-wrapper{
    @include display-flex(row, center,space-between);
    margin-inline-end: 0.3em;
    margin-block-end: 0.5em;
    margin-inline-start: 0.3em;
  }

  .left-section{
    @include display-flex(row, center);
  }
  h3{
    @include sans-serif;
    font-size: 1.1rem;
    margin: 0;
  }
  .show-advanced-list-browser{
    margin-inline-start: 2rem;
    @include shy;
    &:hover{
      text-decoration: underline;
    }
  }
  .counter{
    @include counter-commons;
    background-color: white;
    font-size: 1rem;
    margin-inline-start: 0.5em;
  }
</style>
